import Comments from "../../components/comments";

export default function AddEditComments({ type, obj, route, quarter }) {
    return <Comments type={type} route={route} obj={obj} quarter={quarter} />;
}
